import React from "react";
import PhoneMockup from "./PhoneMockup";

const Hero = ({ t }) => {
  return (
    <section className="hero" id="top">
      {/* 背景裝飾 — 簡潔幾何 */}
      <div className="hero-decor">
        <span className="hd hd-ring hd-1" />
        <span className="hd hd-ring hd-2" />
        <span className="hd hd-dot hd-3" />
        <span className="hd hd-dot hd-4" />
      </div>

      <div className="container">
        <div className="hero-layout">
          {/* 左側文字 */}
          <div className="hero-left">
            <p className="hero-sub">{t.hero.subtitle}</p>
            <h1 className="hero-title">{t.hero.title}</h1>
            <a
              href="https://play.google.com/store/apps/details?id=network.loki.messenger.cn&hl=zh"
              className="btn-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.hero.cta}
            </a>
          </div>

          {/* 右側手機 */}
          <div className="hero-right">
            <PhoneMockup t={t} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
